import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EscalationsComponent } from './escalations.component';
import {T2TemplateBasicComponent} from '../../trip2-theme/components/t2-template-basic/t2-template-basic.component';

const routes: Routes = [
  { path: 'pages', component: T2TemplateBasicComponent,
    children: [
      { path: 'dispatch',
        children: [
          { path: 'escalations', component: EscalationsComponent, data: { title: 'Escalations'} }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class EscalationsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/escalations/escalations-routing.module.ts